import { Pill } from '@mantine/core';
import { invokeEvent, ROOT_SECTION } from 'shared-base';
import Icon from '../Icon/Icon';
import { Categories, Details, Name, Oval, Overlay, Sphere, Wrapper } from './SingleMaterial.style';
import { textureExists } from './SingleMaterial.utils';

export type SingleMaterialProps = {
  material: IMaterial;
  onRemove: () => void;
};

const ROOT = ROOT_SECTION('materials');

export function SingleMaterial(props: SingleMaterialProps) {
  const { material } = props;
  const { id, name, category, style } = material ?? {};

  if (!textureExists(material)) return null;

  function onMouseEnter() {
    invokeEvent('material/preview', { item: material });
  }

  return (
    <Wrapper className='SingleMaterial-wrapper' data-testid='SingleMaterial-wrapper'>
      <Oval
        onMouseEnter={onMouseEnter}
        onClick={props.onRemove}
        title={`${id}\n${name}\n${category}`}
      >
        <Sphere src={`${ROOT}/${id}.thumb.jpg`} />
        <Overlay className='overlay'>
          <Icon name='IconX' size={25} />
        </Overlay>
      </Oval>
      <Details>
        <Name>{name}</Name>
        <Categories>
          <Pill className='pill'>{style}</Pill>
          <Pill className='pill'>{category}</Pill>
        </Categories>
      </Details>
    </Wrapper>
  );
}

export default SingleMaterial;
